import { useEffect, useRef, useState } from "react";
import { FiChevronDown, FiChevronUp, FiSearch } from "react-icons/fi";

export const CustomSelect = ({
  value,
  options,
  onChange,
  placeholder = "Select...",
  style,
  isMulti = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const ref = useRef(null);
  const searchRef = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setIsOpen(false);
        setSearchQuery("");
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  useEffect(() => {
    if (isOpen && searchRef.current) {
      searchRef.current.focus();
    }
    if (!isOpen) {
      setSearchQuery("");
    }
  }, [isOpen]);

  const filteredOptions = options.filter((opt) =>
    opt.label.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const selectedLabels = isMulti
    ? options
        .filter((o) => Array.isArray(value) && value.includes(o.value))
        .map((o) => o.label)
    : [options.find((o) => o.value === value)?.label].filter(Boolean);

  const displayLabel =
    selectedLabels.length > 0 ? selectedLabels.join(", ") : placeholder;

  const isSelected = (optValue) => {
    if (isMulti) {
      return Array.isArray(value) && value.includes(optValue);
    }
    return optValue === value;
  };

  const handleOptionClick = (optValue) => {
    if (isMulti) {
      const nextValue = Array.isArray(value) ? [...value] : [];
      const existingIndex = nextValue.indexOf(optValue);
      if (existingIndex >= 0) {
        nextValue.splice(existingIndex, 1);
      } else {
        nextValue.push(optValue);
      }
      onChange(nextValue);
    } else {
      onChange(optValue);
      setIsOpen(false);
      setSearchQuery("");
    }
  };

  return (
    <div ref={ref} className="custom-select-wrapper" style={style}>
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="custom-select-btn"
      >
        <span style={{ color: selectedLabels.length ? "#1e2a3a" : "#6c757d" }}>
          {displayLabel}
        </span>
        {isOpen ? (
          <FiChevronUp size={14} color="#6c757d" />
        ) : (
          <FiChevronDown size={14} color="#6c757d" />
        )}
      </button>
      {isOpen && (
        <div className="custom-select-dropdown">
          <div
            style={{
              padding: "0.4rem 0.5rem",
              borderBottom: "1px solid #e9ecef",
              display: "flex",
              alignItems: "center",
              gap: "0.375rem",
              backgroundColor: "#f8f9fa",
            }}
          >
            <FiSearch size={13} color="#6c757d" style={{ flexShrink: 0 }} />
            <input
              ref={searchRef}
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Search..."
              onMouseDown={(e) => e.stopPropagation()}
              style={{
                border: "none",
                outline: "none",
                background: "transparent",
                fontSize: "0.8rem",
                width: "100%",
                color: "#1e2a3a",
              }}
            />
          </div>
          {filteredOptions.length > 0 ? (
            filteredOptions.map((opt) => (
              <button
                key={opt.value}
                type="button"
                onClick={() => handleOptionClick(opt.value)}
                className={`custom-select-option ${isSelected(opt.value) ? "active" : ""}`}
              >
                {opt.label}
              </button>
            ))
          ) : (
            <div
              style={{
                padding: "0.5rem 0.75rem",
                fontSize: "0.8rem",
                color: "#6c757d",
                textAlign: "center",
              }}
            >
              No results found
            </div>
          )}
        </div>
      )}
    </div>
  );
};
